import { render, staticRenderFns } from "./InvestorForm.vue?vue&type=template&id=8dd23dde&scoped=true"
import script from "./InvestorForm.vue?vue&type=script&lang=js"
export * from "./InvestorForm.vue?vue&type=script&lang=js"
import style0 from "./InvestorForm.vue?vue&type=style&index=0&id=8dd23dde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dd23dde",
  null
  
)

export default component.exports